import React from 'react';

import { List } from './List';
import { Edit } from './Edit';

export const restaurantsSampleRoutes = {
  path: '/restaurantsSample',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/edit',
      element: <Edit slug='/restaurantsSample' />,
    },
    {
      path: 'add',
      element: <Edit slug='/restaurantsSample' />,
    },
  ],
};
